import { ConnectionHardwareConfiguration } from '@paragon/contract-library';

import { DesignService } from '../connections';

// The server sets headers to cache the configuration route for one day.  Since this cacheBustGuid lives at the module
//   level, it will remain the same as long as this instance of the client is alive.  With these two behaviors combined,
//   the list of configurations will remain cached for one day or until the page is reloaded, whichever comes first.
const cacheBustGuid = crypto.randomUUID();

export function getAllHangerConfigurations(): Promise<ConnectionHardwareConfiguration[]> {
  return DesignService.get(`hangerConnectors/configurations`, { params: new URLSearchParams({ cacheBustGuid }) });
}
